export const applicationRouteNames = {
  home: 'historique-contrats',
  administration: 'administration',
  users: 'users',
  lokalise: 'lokalise',
  nouvelleDemande: 'nouvelle-demande',
  formulaireRecruteur: 'formulaire-recruteur',
  avenant: 'avenant',
  historiqueContrats: 'historique-contrats',
  gestionModeles: 'gestion-modeles',
  revueContrats: 'revue-contrats',
};
